var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "newPopover",
    {
      ref: "newPopover",
      attrs: { title: "修改公司信息" },
      on: {
        dlodingHide: function($event) {
          return _vm.clearData("")
        },
        clearData: function($event) {
          return _vm.clearData(_vm.form.id)
        },
        submitData: _vm.submitData
      }
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.rules,
                "label-width": "110px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "语言", prop: "language" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.language,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "language", $$v)
                        },
                        expression: "form.language"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "中文", value: "zh" }
                      }),
                      _c("el-option", { attrs: { label: "英语", value: "en" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "公司名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入公司名称" },
                    model: {
                      value: _vm.dataForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "name", $$v)
                      },
                      expression: "dataForm.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "公司地址", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入公司地址" },
                    model: {
                      value: _vm.dataForm.address,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "address", $$v)
                      },
                      expression: "dataForm.address"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "email", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入email" },
                    model: {
                      value: _vm.dataForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "email", $$v)
                      },
                      expression: "dataForm.email"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "经纬度", prop: "latitude" } },
                [
                  _c(
                    "div",
                    { staticClass: "x-bc" },
                    [
                      _c("el-input", {
                        staticStyle: { width: "48% !important" },
                        attrs: { clearable: "", placeholder: "经度" },
                        model: {
                          value: _vm.dataForm.latitude,
                          callback: function($$v) {
                            _vm.$set(_vm.dataForm, "latitude", _vm._n($$v))
                          },
                          expression: "dataForm.latitude"
                        }
                      }),
                      _c("el-input", {
                        staticStyle: { width: "48% !important" },
                        attrs: { clearable: "", placeholder: "纬度" },
                        model: {
                          value: _vm.dataForm.longitude,
                          callback: function($$v) {
                            _vm.$set(_vm.dataForm, "longitude", _vm._n($$v))
                          },
                          expression: "dataForm.longitude"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮政编码", prop: "postcode" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入邮政编码" },
                    model: {
                      value: _vm.dataForm.postcode,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "postcode", $$v)
                      },
                      expression: "dataForm.postcode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: { label: "二维码图", prop: "cooperationPic" }
                },
                [
                  _c("uploadImage", {
                    ref: "picUploadImage",
                    attrs: { limit: 1, "file-list": _vm.picfileList },
                    on: {
                      change: function($event) {
                        return _vm.picUrl($event)
                      },
                      delUrl: function($event) {
                        return _vm.delUrl($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }